import React from 'react';

import SalesChannelsEdit from '@components/shared/sales_channels/SalesChannelsEdit';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import { inventoryTypeService } from '@services/admin/inventoryTypeService';
import { shippingTypeService } from '@services/admin/shippingTypeService';
import { salesChannelService } from '@services/admin/salesChannelService';

// Admin session 已鎖定單一 merchant，MerchantDataContext 直接提供該 merchant 的
// inventoryTypes / shippingTypes — wrapper 把它們轉發給 shared，shared 不再讀
// useOperatorData()。
const AdminSalesChannelsEdit: React.FC = () => {
  const { inventoryTypes, shippingTypes, loading } = useMerchantData()!;

  return (
    <SalesChannelsEdit
      role="admin"
      salesChannelService={salesChannelService}
      inventoryTypeService={inventoryTypeService}
      shippingTypeService={shippingTypeService}
      inventoryTypes={inventoryTypes}
      shippingTypes={shippingTypes}
      merchantDataLoading={Boolean(loading)}
    />
  );
};

export default AdminSalesChannelsEdit;
